import React from 'react';
import { Link } from 'react-router-dom';

const UnauthorizedPage = () => {
  return (
    <div className="error-page">
      <h1>401 Unauthorized</h1>
      <p>You are not authorized to view this page. Please log in again to access the resource.</p>
      <Link to="/login">Go to Login</Link>
    </div>
  );
};

export default UnauthorizedPage;
